import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import SubNav from './Common/SubNav';
import Footer from './Common/Footer';
import { useDispatch } from 'react-redux';
import { alertAction } from '../Redux/Actions/alertAction';

const AddPackage = ({ isShow, setIsShow }) => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const initialValues = { pkgName: '', pkgGroup: '', pkgPeriod: '', memberFee: '', prgFee: '', days: '', status: '' };
    const [formErrors, setFormErrors] = useState({});
    const [formValues, setFormValues] = useState(initialValues);
    const [isSubmit, setIsSubmit] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'pkgPeriod' && value === 'MONTHLY') {
            setFormValues({ ...formValues, days: 30, [name]: value });
        }
        else if (name === 'pkgPeriod' && value === 'QUARTERLY') {
            setFormValues({ ...formValues, days: 30 * 3, [name]: value });
        }
        else if (name === 'pkgPeriod' && value === 'HALF YEARLY') {
            setFormValues({ ...formValues, days: 30 * 6, [name]: value });
        }
        else if (name === 'pkgPeriod' && value === 'YEARLY') {
            setFormValues({ ...formValues, days: 30 * 12, [name]: value });
        }
        else {
            setFormValues({ ...formValues, [name]: value });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setFormErrors(validate(formValues));
        setIsSubmit(true);
        console.log(formValues);
    }

    useEffect(() => {
        if (Object.keys(formErrors).length === 0 && isSubmit) {
            navigate('/admin/package/all');
            dispatch(alertAction())
            setIsSubmit(false)
        }
    }, [isSubmit, formErrors]);

    const validate = (values) => {
        const errors = {};
        if (!values.pkgName) {
            errors.pkgName = "This field is mandatory!"
        }
        if (values.pkgPeriod === '') {
            errors.pkgPeriod = "Package period must be selected!"
        }
        if (values.pkgGroup === '') {
            errors.pkgGroup = "Package group must be selected!"
        }
        if (!values.memberFee) {
            errors.memberFee = "This field is mandatory!"
        }
        if (!values.prgFee) {
            errors.prgFee = "This field is mandatory!"
        }
        return errors;
    };

    useEffect(() => {
        if (slug) {
            setFormValues({ pkgName: '6 month', pkgGroup: 'Fitness', pkgPeriod: 'MONTHLY', memberFee: '400', prgFee: '1000', days: '30', status: 'Inactive' })
        }
    }, [slug]);


    return (
        <div className='page_first_div'>
            <SubNav isShow={isShow} setIsShow={setIsShow} />
            <div className='page_sec_div '>
                <p className='page_topic inline-block'>{`${slug ? "Edit" : "Add New"} Package`}</p>
                <div className='inline-block bg-cyan-600 px-3 py-1 ml-2 rounded-md hover:bg-cyan-700 animation'>
                    <Link to="/admin/package/all" className='link block text-white text-sm'>
                        <i className="fa-solid fa-arrow-left mr-1"></i>
                        All
                    </Link>
                </div>

                <section className='page_section px-4 xsm:px-8 py-2 min-h-[23rem]'>
                    <form action="" onSubmit={handleSubmit}>
                        <div className='grid gap-4 lg:grid-cols-2 lg:gap-6 pt-10'>
                            <div className='font-lato text-sm xsm:text-base '>
                                <p className='text-gray-800 font-semibold tracking-wider '>Package Name<span className='text-red-500'>&#42;</span></p>
                                <input type="text" className='form_input border-2 h-10 w-full placeholder:text-xs xsm:placeholder:text-sm' placeholder='Enter Program Name' name='pkgName' value={formValues.pkgName} onChange={handleChange} />
                                <small className='text-red-500 tracking-wide'>{formErrors.pkgName}</small>
                            </div>
                            <div className='font-lato '>
                                <p className='text-gray-800 font-semibold tracking-wider text-sm xsm:text-base'>Package Group<span className='text-red-500'>&#42;</span></p>
                                <select className="selector" name='pkgGroup' value={formValues.pkgGroup} onChange={handleChange}>
                                    <option value=''>--Select Program Group--</option>
                                    <option value="Fitness">Fitness</option>
                                    <option value="Growth">Growth</option>
                                </select>
                                <small className="text-red-500 tracking-wide">{formErrors.pkgGroup}</small>
                            </div>
                            <div className='font-lato '>
                                <p className='text-gray-800 text-sm sm:text-base font-semibold tracking-wider'>Package Period<span className='text-red-500'>&#42;</span></p>
                                <select className="selector" name='pkgPeriod' value={formValues.pkgPeriod} onChange={handleChange}>
                                    <option value=''>--Select Package Period--</option>
                                    <option value="HALF YEARLY">HALF YEARLY</option>
                                    <option value="QUARTERLY">QUARTERLY</option>
                                    <option value="MONTHLY">MONTHLY</option>
                                    <option value="YEARLY">YEARLY</option>
                                </select>
                                <small className="text-red-500 tracking-wide">{formErrors.pkgPeriod}</small>
                            </div>
                            <div className='font-lato text-sm xsm:text-base '>
                                <p className='text-gray-800 font-semibold tracking-wider '>Number of days<span className='text-red-500'>&#42;</span></p>
                                <input type="number" className='form_input border-2 h-10 w-full placeholder:text-xs xsm:placeholder:text-sm' placeholder='Enter No. of days' name='days' value={formValues.days} onChange={handleChange} disabled />
                            </div>
                            <div className='font-lato text-sm xsm:text-base '>
                                <p className='text-gray-800 font-semibold tracking-wider'>Member Fee<span className='text-red-500'>&#42;</span></p>
                                <div className='flex justify-center items-baseline h-10 w-full border-2 text-gray-700 outline-gray-300 rounded'>
                                    <p className='h-full text-center flex-1 px-1 sm:px-0'>Rs.</p>
                                    <input type="number" className='placeholder:text-xs xsm:placeholder:text-sm placeholder:text-gray-700 text-sm flex-[9] outline-none h-full pr-6 border-l-2 pl-2' placeholder='Enter Enrollment Fees' name='memberFee' value={formValues.memberFee} onChange={handleChange} />
                                </div>
                                <small className="text-red-500 tracking-wide">{formErrors.memberFee}</small>
                            </div>
                            <div className='font-lato text-sm xsm:text-base '>
                                <p className='text-gray-800 font-semibold tracking-wider'>Program Fee<span className='text-red-500'>&#42;</span></p>
                                <div className='flex justify-center items-baseline h-10 w-full border-2 text-gray-700 outline-gray-300 rounded'>
                                    <p className='h-full text-center flex-1 px-1 sm:px-0'>Rs.</p>
                                    <input type="number" className='placeholder:text-xs xsm:placeholder:text-sm placeholder:text-gray-700 text-sm flex-[9] outline-none h-full pr-6 border-l-2 pl-2' placeholder='Enter Program Fees' name='prgFee' value={formValues.prgFee} onChange={handleChange} />
                                </div>
                                <small className="text-red-500 tracking-wide">{formErrors.prgFee}</small>
                            </div>
                            <div className='font-lato '>
                                <p className='text-gray-800 font-semibold tracking-wider text-sm xsm:text-base'>Status<span className='text-red-500'>&#42;</span></p>
                                <select className="selector" name='status' value={formValues.status} onChange={handleChange}>
                                    <option value="Active" >Active</option>
                                    <option value="Inactive">Inactive</option>
                                </select>
                            </div>
                        </div>

                        <div className='pt-4 lg:pt-10'>
                            <button className='button mr-2 ' type='submit' >{`${slug ? "Update" : "Save"}`}</button>
                            <button className='button2' type='reset' onClick={() => setFormValues(initialValues)}>Reset</button>
                        </div>
                    </form>
                </section>
            </div>
            <Footer />
        </div>
    )
}
export default AddPackage;